import { render } from "./orderDetail.vue?vue&type=template&id=779b0600"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"

import exportComponent from "F:\\ydd\\h5\\pda_dealer_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__